<template>
    <a :href="$route('subscriptions.customers.invoices', uid)">
        {{ total }}
        <span class="d-none d-xl-inline-block"> {{ __('subscriptions.invoices') }}</span>
    </a>
</template>

<script>
export default {
    props: {
        total: Number,
        uid: {
            type: String,
            default() {
                return this.$page.props.auth_uid
            }
        }
    }
}
</script>
